import React from 'react'
import { Box } from '@mui/material'
import images from 'assets/images'
import SignUpBuyerOptions from 'components/pages/signup/SignUpBuyerOptions'
import { useParams } from 'react-router-dom'
import SignupTemplate from 'components/templates/SignupTemplate'
import SignUpProductPreviewMaven from 'components/pages/signup/SignUpProductPreviewMaven'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import { Product } from 'type/types'

const ADVANTAGES: Advantage[] = [
  {
    image: images.signUp.ONE_STOP_SHOP,
    alt: 'Software and services',
    title: '<strong>One-stop shop</strong> for software & services!',
    text: 'Buy software products at massive discounts. And find service providers who can help you operate your company. All in one place.',
  },
  {
    image: images.signUp.SERVICE_PROVIDERS,
    alt: 'Service providers',
    title: 'Choose from <strong>thousands of service providers</strong>',
    text: 'Browse, search and filter. Learn about their specific skill sets. Read reviews from past or current customers.',
  },

  {
    image: images.signUp.PUZZLE_PIECES,
    alt: 'Get matched',
    title: '<strong>Get matched</strong> with your ideal service provider',
    text: "NachoNacho's deep knowledge of both businesses like you as well as service providers facilitates perfect match-making.",
  },
]

type ProductData = Pick<Product, 'id' | 'name' | 'nameFile' | 'visibility' | 'offer' | 'offer2'>

type Props = {
  product: ProductData
}

const SignUpProductMaven: React.FC<Props> = ({ product }) => {
  const params = useParams()

  return (
    <SignupTemplate
      left={
        <Box style={{ textAlign: 'center' }}>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="38px" />

          <Box className="fs-32">
            <h2 className="text-dark-blue fs-32 m-0 d-inline">Get your business serviced!</h2>
          </Box>
          <Box className="fs-20" mt="16px" lineHeight="30px" maxWidth="512px" mx="auto">
            NachoNacho Mavens is the premier destination for service providers to offer their services to businesses.
          </Box>

          <Box height="55px" />

          <AdvantagesContainer advantages={ADVANTAGES} />

          <Box height="57px" />

          <img src={images.LOGO_NN_BLUE} style={{ width: '197px' }} />
        </Box>
      }
      right={
        <>
          {params.productId && <SignUpProductPreviewMaven product={product} />}
          <SignUpBuyerOptions />
        </>
      }
    />
  )
}

export default SignUpProductMaven
